module.exports = __webpack_public_path__ + "img/chinaEurope01_E.82b68d7d.png";